import React, { Fragment, useState } from 'react';
import T from 'prop-types';

import DeleteModal from '../../../../../components/DeleteModal';
import { toast } from '../../../../../components/Toasts';
import api from '../../../api';

const DeleteExportModal = ({ open, report, onDeleteSuccess, onClose }) => {
  const [pending, setPending] = useState(false);

  const handleModalClose = () => {
    if (pending) return;
    onClose();
  };

  const handleExportDelete = () => {
    if (pending) return;

    setPending(true);

    api.customExports
      .deleteCustomExport(report.id)
      .then(() => {
        setPending(false);

        toast.error('Export has been deleted successfully.');

        if (onDeleteSuccess) onDeleteSuccess();
        handleModalClose();
      })
      .catch(() => {
        setPending(false);

        toast.error('Oops! Something went wrong. Please, try again later');
      });
  };

  return (
    <DeleteModal
      open={open}
      buttonSize="lg"
      confirmButtonText="Delete Export"
      confirmMessage={
        <Fragment>
          <span className="text-black">Delete Export?</span>
          <small>This cannot be undone</small>
        </Fragment>
      }
      closeButtonIconClass="hicon-close"
      onClose={handleModalClose}
      onDelete={handleExportDelete}
    />
  );
};

DeleteExportModal.propTypes = {
  open: T.bool.isRequired,
  report: T.object.isRequired,
  onDeleteSuccess: T.func,
  onClose: T.func.isRequired,
};

export default DeleteExportModal;
